import { defineMessages } from 'react-intl';

export const i18n: {
	statusLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	statusLabel: {
		id: 'search-page.filters.names.status',
		defaultMessage: 'Status',
		description:
			'The text is shown as the filter name label in the search filter bar, allowing users to narrow results by item status.',
	},
});
